import { render, staticRenderFns } from "./authSAML.vue?vue&type=template&id=aaa24b94&scoped=true"
import script from "./authSAML.vue?vue&type=script&lang=js"
export * from "./authSAML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa24b94",
  null
  
)

export default component.exports